import { createContext, useContext, useCallback, useRef, useState } from 'react'

const AnnouncerContext = createContext(null)

/**
 * Provides an aria-live region for screen reader announcements.
 * Usage: const announce = useAnnounce(); announce('Trade executed successfully')
 */
export function LiveAnnouncerProvider({ children }) {
  const [message, setMessage] = useState('')
  const timeoutRef = useRef(null)

  const announce = useCallback((text, _priority = 'polite') => {
    // Clear then set to force re-announcement of same message
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setMessage('')
    timeoutRef.current = setTimeout(() => setMessage(text), 100)
  }, [])

  return (
    <AnnouncerContext.Provider value={announce}>
      {children}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {message}
      </div>
    </AnnouncerContext.Provider>
  )
}

export function useAnnounce() {
  const ctx = useContext(AnnouncerContext)
  if (!ctx) return () => {} // noop fallback
  return ctx
}
